// Axis labels and steps for the growth charts.
//
// Bucket labels are derived from `start`, not from the payload's `label` field:
// that field is `YYYY-MM` whatever the interval is, so on weekly buckets it
// repeats itself four times down the axis. The date is unambiguous at both
// intervals and costs one parse.
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Parsed as a LOCAL date, not with Date.parse. 'YYYY-MM-DD' is treated as UTC
// midnight by the spec, which renders as the previous evening anywhere west of
// Greenwich — so a bucket starting on 1 September labels itself "Aug 31" for
// every user in this product's home time zone.
const asDate = (iso) => {
  const [y, m, d] = String(iso).slice(0, 10).split("-").map(Number);
  return new Date(y, m - 1, d);
};

// The year rides along on January and on the school year's own start, which are
// the two places a reader needs it and the only two where it isn't clutter.
const bucketLabel = (bucket, interval) => {
  const d = asDate(bucket.start);
  const month = MONTHS[d.getMonth()];
  if (interval === "week") return `${month} ${d.getDate()}`;
  const year = d.getMonth() === 0 || d.getMonth() === 7
    ? ` '${String(d.getFullYear()).slice(2)}` : "";
  return `${month}${year}`;
};

// A gridline step that lands on whole standards. Counts, so a fractional step
// would put "2.5 standards" on an axis.
const countStep = (span, target = 8) => Math.max(1, Math.ceil(span / target));

// How many x labels fit. Below this the months collide, and a collided axis is
// worse than a thinned one.
const labelEvery = (n, width, per = 46) =>
  Math.max(1, Math.ceil(n / Math.max(1, Math.floor(width / per))));

const dayCount = (fromIso, toIso) =>
  Math.round((asDate(toIso) - asDate(fromIso)) / 86400000);

const shortDate = (iso) => {
  const d = asDate(iso);
  return `${MONTHS[d.getMonth()]} ${d.getDate()}`;
};

export { asDate, bucketLabel, countStep, labelEvery, dayCount, shortDate };
